import { MasterDataReportListSearchCriteria } from '../models';
import { MasterDataType } from '../constants';

export class MasterDataReportItemListLoad {
  public static readonly type = '[MasterDataReportItem] List load';
  constructor(public payload: MasterDataReportListSearchCriteria) {}
}

export class MasterDataReportItemSetInitialData {
  public static readonly type = '[MasterDataReportItem] Set initial data';

  constructor(public payload: { id: string; type: MasterDataType }) {}
}

export class MasterDataReportItemInitialState {
  public static readonly type = '[MasterDataReportItem] Set initial state';
}
